<template>
  <el-container style="height: 100%">
    <el-aside class="sider" :class="{ 'is-collapsed': isMenuCollapse }">
      <el-button type="text" class="toggle-btn" @click="toggleMenu">
        <svgicon name="menu"></svgicon>
      </el-button>
      <a class="logo" href="#">
        <el-image :src="$store.state.logoUrl" fit="contain"></el-image>
      </a>
      <div class="sider-c">
        <el-menu
          :default-active="$route.path"
          unique-opened
          @open="handleOpen"
          @close="handleClose"
          :collapse="isMenuCollapse"
        >
          <h4>MENU</h4>
          <template
            v-for="(item, index) in $router.options.routes"
            v-if="!item.hidden && getPermission(item.name)"
          >
            <el-submenu v-if="getLeaf(item)" :index="item.path">
              <template slot="title">
                <svgicon
                  :name="item.icon"
                  :original="true"
                  :class="'svg-' + item.icon"
                ></svgicon>
                <span slot="title">{{ item.meta.title }}</span>
              </template>
              <el-menu-item
                v-for="child in item.children"
                v-if="!child.hidden && getPermission(child.name)"
                :key="child.path"
                :index="item.path + '/' + child.path"
                @click="selectItem(item, child)"
              >
                <span slot="title">{{ child.meta.title }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-else
              :index="item.path"
              @click="selectItem(item, '')"
            >
              <svgicon
                :name="item.icon"
                :original="true"
                :class="'svg-' + item.icon"
              ></svgicon>
              <span slot="title">{{ item.meta.title }}</span>
            </el-menu-item>
          </template>
          <h4>OTHER</h4>
          <el-menu-item index="download">
            <!-- <svgicon
              name="download"
              :original="isSelectedMenu.name != item.name"
              :class="'svg-' + item.icon"
            ></svgicon>-->
            <svgicon
              name="download"
              :original="true"
              class="svg-download"
            ></svgicon>
            <span slot="title">{{ $l("下载管理") }} </span>
          </el-menu-item>
          <el-menu-item index="help">
            <svgicon name="doc" :original="true" class="svg-doc"></svgicon>
            <span slot="title">{{ $l("帮助文档") }} </span>
          </el-menu-item>
        </el-menu>
        <el-row type="flex" justify="center">
          <el-button
            type="primary"
            round
            @click="logout"
            v-show="!isMenuCollapse"
            >Logout</el-button
          >
        </el-row>
      </div>
    </el-aside>
    <el-container>
      <el-header height="112px" class="header">
        <!-- <router-link class="logo" to="/"></router-link> -->
        <div class="header__title">
          <h2>
            {{ $route.matched[0].meta.title }}
            <span v-if="$route.matched[0].redirect"
              >｜{{ $route.meta.title }}</span
            >
          </h2>
          <p>{{ $route.matched[0].meta.info }}</p>
        </div>
        <el-row type="flex" class="header__avatar">
          <el-col>
            <h4>{{ user.username }}</h4>
            <p>{{ user.roleName }}</p>
          </el-col>
          <el-avatar :src="avatarUrl" fit="cover"></el-avatar>
          <!-- <li @click="logout()"><i class="logout"></i>退出</li> -->
        </el-row>
      </el-header>

      <!-- <el-container> -->
      <el-main>
        <transition :name="pageTransition">
          <router-view v-if="isReloadAlive"></router-view>
        </transition>
      </el-main>
      <!-- </el-container> -->
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import "@/icons";
// import logoUrl from "@/assets/img/logo_w.png";
// import avatarUrl from "@/assets/img/user_head.png";

export default {
  name: "home",
  components: {
    // HelloWorld
  },
  data() {
    return {
      siderWidth: "300px",
      isMenuCollapse: false,
      isReloadAlive: true,
      user: null,
      isSelectedMenu: {
        name: "",
        index: "",
      },
      // logoUrl: require("@/assets/img/logo_w.png"),
      // logoUrl: require("@/assets/img/display_03.jpg"),
      avatarUrl: require("@/assets/img/user_head.png"),
      interval: "",
      pageTransition: "none",
    };
  },
  methods: {
    handleOpen() {},
    handleClose() {},
    selectItem(item, child) {
      let itemPath = item.path;
      let childPath = child ? child.path : "";
      let path = itemPath + "/" + childPath;
      this.isSelectedMenu.name = item.name;

      if (item.leaf) {
        path = itemPath;
      }
      this.$router.push(path);
      this.reload();
    },
    // selectRootItem() {},
    //选择菜单栏目
    menuHoverCancel() {},
    menuHover(index) {},
    onSubmit() {},
    //退出登录
    logout() {
      this.$confirm(this.$l("确认退出吗?"), this.$l("退出系统"), {
        type: "warning",
      })
        .then(() => {
          this.$http
            .get(this.$apiConfig.user_logout_url, {
              params: {
                username: this.$store.state.user.username,
              },
            })
            .then((response) => {})
            .catch((error) => {
              this.$sentry.captureException(error);
            });
          sessionStorage.clear();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {});
    },
    reload() {
      this.isReloadAlive = false;
      this.$nextTick(() => {
        this.isReloadAlive = true;
      });
    },
    toggleMenu() {
      this.isMenuCollapse = !this.isMenuCollapse;
      if (this.isMenuCollapse) {
        this.siderWidth = "60px";
      } else {
        this.siderWidth = "300px";
      }
    },
    getPermission(name) {
      if (this.user.roleType == 1) {
        return true;
      }
      let permissionArr = this.$store.state.permissions.filter(
        (item) => item.name == name
      );
      if (permissionArr.length == 1) {
        return permissionArr[0];
      }
      return false;
    },
    getLeaf(item) {
      if (this.user.roleType == 1) {
        return !item.leaf;
      }
      let permissionId = 0;
      let permissions = this.$store.state.permissions.filter(
        (n) => n.name == item.name
      );
      if (permissions.length == 1) {
        permissionId = permissions[0].permissionId;
      }
      let result =
        this.$store.state.permissions.filter(
          (item) => item.parentId == permissionId
        ).length > 0;
      return result;
    },
    autoPageScroll(list) {
      let pageList = list;
      let i = 0;
      this.interval = setInterval(() => {
        i = i % pageList.length;
        this.$router.push(pageList[i]);
        i++;
      }, 3000);
    },
    stopPageScroll() {
      clearInterval(this.interval);
    },
  },
  provide() {
    return {
      reload: this.reload,
      autoPageScroll: this.autoPageScroll,
      stopPageScroll: this.stopPageScroll,
    };
  },
  mounted() {
    // window.onresize = () => {
    //   return (() => {
    //     // this.reload();
    //   })();
    // };
    if (this.isPageScroll) {
      this.pageTransition = "slide-left";
    } else {
      this.pageTransition = "none";
    }
  },
  created() {
    this.$store.state.user = JSON.parse(localStorage.getItem("user"));
    this.user = this.$store.state.user;
    this.$http
      .get(this.$apiConfig.get_account__url + this.user.userId)
      .then((response) => {
        let result = response.data;
        if (result.code == 0) {
          let data = result.data;
          this.$store.state.user = data;
          sessionStorage.setItem("user", JSON.stringify(data));
          this.user = data;
          if (this.user.roleType != 1) {
            this.$http
              .get(
                this.$apiConfig.get_role_permissionName_url +
                  "/" +
                  this.user.roleId
              )
              .then((response) => {
                let result = response.data;
                if (result.code == 0) {
                  let data = result.data;
                  this.$store.state.permissions = data;
                  localStorage.setItem("permissions", JSON.stringify(data));
                }
              })
              .catch((error) => {
                this.$sentry.captureException(error);
              });
          }
        }
      })
      .catch((error) => {
        this.$sentry.captureException(error);
      });
  },
  computed: {
    isPageScroll() {
      return this.$store.state.isPageScroll;
    },
  },
  watch: {
    isPageScroll(val, oldVal) {
      if (val) {
        this.pageTransition = "slide-left";
      } else {
        this.pageTransition = "none";
      }
    },
  },
};
</script>
<style lang="scss">
.el-container {
  position: relative;
  min-height: 0;
  flex: 1;
}
.header {
  position: relative;
  display: flex;
  padding-left: 0;
  // background: #fff;
  // background-size: cover;

  &__title {
    padding-top: 34px;
    flex: 1;
    // color: $--color-primary;
    padding-left: 22px;
    h2 {
      font-size: 29px;
      // font-weight: bold;
      padding-left: 0px;
      margin: 0;
      line-height: 35px;
    }
    p {
      color: #9fa0a0;
      font-size: 16px;
    }
  }
  &__avatar {
    padding-top: 40px;
    text-align: right;
    h4 {
      font-size: $--font-size-large;
    }
    p {
      color: $--color-text-secondary;
      font-size: $--font-size-small;
    }
    .el-avatar {
      min-width: 45px;
      min-height: 45px;
      margin-left: 10px;
    }
  }
  ul {
    display: flex;
    color: #6e7e95;
    li {
      margin: 0 20px;
      line-height: 60px;
      i {
        display: inline-block;
        vertical-align: middle;
        height: 18px;
        width: 18px;
        margin-right: 5px;
        background-position: center top;
        background-repeat: no-repeat;
      }
    }
  }
}
.sider {
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  height: 100%;
  background: $--color-black;
  transition: all 0.2s ease;
  width: 300px !important;
  .logo {
    display: inline-block;
    // width: 300px;
    width: 100%;
    // height: 100%;
    height: 112px;
    padding-top: 15px;
    padding-left: 20px;
    background: $--color-black;
    display: flex;
    align-items: center;
    // background: url("../assets/img/dianxin.png") no-repeat center;
    .el-image {
      max-width: 250px;
      height: 90px;
      .el-image__inner {
        width: auto;
        max-width: 280px;
      }
    }
  }
  .el-button.toggle-btn {
    position: absolute;
    right: 20px;
    top: 40px;
    width: auto;
    margin: 0;
    svg {
      width: 18px;
      height: 18px;
    }
  }

  h4 {
    font-size: $--font-size-large;
    padding: 0.5em 0;
    margin: 20px 0 0 20px;
    color: $--menu-item-font-color;
    border-bottom: 1px solid #4e5256;
  }
  &-c {
    flex: 1;
    // display: flex;
    // flex-direction: column;
    overflow-y: auto;
    // padding-bottom: 50px;
    .el-button {
      width: 9em;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    @extend %scroll;
  }
  .el-menu--collapse {
    width: 60px;
    h4 {
      overflow: hidden;
      height: 0;
      // width: 0;
      margin: 0px 20px 0;
      padding: 0;
    }
    .el-tooltip {
      text-align: center;
    }
    .svg-icon {
      margin: auto;
    }
  }
  &.is-collapsed {
    width: 60px !important;
    .el-image {
      display: none;
    }
  }
}
.el-menu {
  border-right: 0;
  .svg-icon {
    width: 18px;
    height: 18px;
    margin-right: 20px;
  }
  .is-active {
    .svg-icon {
      path {
        fill: #fff;
      }
      // fill: none;
      [pid="1"] {
        fill: $--color-primary;
        stroke: none;
      }
    }
    // .svg-all [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-run [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-shield [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-pie [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-screen [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
    // .svg-cog [pid="1"] {
    //   fill: $--color-primary;
    //   stroke: none;
    // }
  }
  // .el-menu-item,
  // .el-submenu__title {
  //   padding-left: $--base-padding !important;
  // }
  .el-submenu .el-menu-item {
    font-size: $--font-size-small;
    padding-left: ($--base-padding + 38) !important;
    height: 35px;
    line-height: 35px;
  }
}
.el-main {
  padding: 25px;
  padding-top: 0;
  padding-bottom: 0;
  background-size: cover;
  // height: calc(100% - 54px);
  height: 100%;
  position: relative;
  overflow-x: hidden;
  background: rgba(#fff, 0.8);
  border-top-left-radius: 20px;
  > div {
    position: absolute;
    left: 0;
    right: 0;
    padding: 0 25px;
    padding-top: 25px;
    // left: $--base-padding;
    // right: $--base-padding;
    top: 0px;
    bottom: 0px;
    overflow: auto;
    // height: auto;
    // width: 100%;
  }
}

//----------------------------
//  自适应
//----------------------------
@media screen and (max-width: $--lg) {
  .sider {
    width: 250px !important;
  }
  .sider .logo .el-image .el-image__inner {
    max-width: 200px;
  }
  .el-main {
    padding: 0 15px;
    > div {
      padding-left: 15px;
      padding-right: 15px;
      padding-top: 15px;
    }
    .container {
      padding-bottom: 15px !important;
    }
  }
}
</style>
